//  @flow

import React from 'react';
import { useTranslation } from 'react-i18next';

import Heading from '../../Components/Heading';
import ImageCard from '../../Components/ImageCard';
import ListGroup from '../../Components/ListGroup';

import TAKE_OFF_jpg from '../../Assets/v2/home/takeoff.jpeg';
import INTERNS_jpg from '../../Assets/v2/home/interns.jpeg';
import DEMO_jpg from '../../Assets/v2/home/demo.jpeg';

import TAKE_OFF_webp from '../../Assets/v2/home/takeoff.webp';
import INTERNS_webp from '../../Assets/v2/home/interns.webp';
import DEMO_webp from '../../Assets/v2/home/demo.webp';

import TAKE_OFF_fallback from '../../Assets/fallbacks/home/takeoff.jpg';
import INTERNS_fallback from '../../Assets/fallbacks/home/interns.jpg';
import DEMO_fallback from '../../Assets/fallbacks/home/demo.jpg';
import Button from '../../Components/Button';

const DataItems = [
  {
    image: TAKE_OFF_jpg,
    webpImage: TAKE_OFF_webp,
    fallbackImage: TAKE_OFF_fallback,
    title: 'takeOff',
    text: 'takeoffText',
    link:
      'https://docs.google.com/spreadsheets/d/1ZTFnuYvfCTiOpcG_2iW6bEMdwX1fzeBuvZFeKqxeR4A/edit?usp=sharing',
    linkText: 'takeoffLink'
  },

  {
    image: INTERNS_jpg,
    fallbackImage: INTERNS_fallback,
    webpImage: INTERNS_webp,
    title: 'interns',
    text: 'internsText',
    link:
      'https://docs.google.com/document/d/1t5s5OJcT_DXErVzJQcGfdOx-_Zxgdxru06SWS7bfmL0/edit?usp=sharing',
    linkText: 'internsLink'
  },

  // {
  //   image: BLOG_jpg,
  //   fallbackImage: BLOG_fallback,
  //   webpImage: BLOG_webp,
  //   title: 'blogs',
  //   text: 'blogsText',
  //   link:
  //     'https://medium.com/@singhsourav206/tutorial-react-portal-4e2eaca084b8',
  //   linkText: 'internsLink'
  // },

  {
    image: DEMO_jpg,
    fallbackImage: DEMO_fallback,
    webpImage: DEMO_webp,
    title: 'demo',
    text: 'demoText',
    link: 'https://www.youtube.com/channel/UCW2xDwSAZs9Yuea_aMrMNBQ',
    linkText: 'demoLink'
  }
];

const openLink = link => {
  window.open(link, '_blank');
};

const Happening = () => {
  const { t } = useTranslation();
  return (
    <ListGroup
      count={3}
      containerClassName="happening-container"
      title={<Heading title={t('happeningHeading')} />}
      description={t('happeningPara')}
      descriptionClassName="happening-container-description">
      {DataItems.map(item => {
        return (
          <ImageCard
            onClick={() => openLink(item.link)}
            key={item.title}
            showImage={true}
            fallbackImage={item.fallbackImage}
            image={item.image}
            webpImage={item.webpImage}
            title={t(item.title)}
            text={t(item.text)}
            isLink={true}>
            <Button
              icon="fas fa-arrow-right"
              primaryFull
              text={t(item.linkText)}
            />
          </ImageCard>
        );
      })}
    </ListGroup>
  );
};

export default Happening;



// WEBPACK FOOTER //
// ./src/Pages/Home/Happenings.js